import { router, usePage } from "@inertiajs/react"
import { useEffect } from "react"
import { toast } from "sonner"

import type { Flash } from "@/types"

export const useFlash = () => {
  // Inertia AJAX nav (router.visit / router.post / etc.) — fires the
  // beforeUpdate event, we toast and clear so the same flash doesn't
  // double-fire on a subsequent partial reload.
  router.on("beforeUpdate", (event) => {
    const flash = event.detail.page.props.flash as Flash
    if (flash.alert) {
      toast.error(flash.alert)
    }
    if (flash.notice) {
      toast(flash.notice)
    }
    event.detail.page.props.flash = {}
  })

  // Full browser navigation (native form POST, hard reload, callback
  // redirect from an external OAuth provider) — beforeUpdate doesn't
  // fire on the initial Inertia mount, so flash sits in page.props
  // and never toasts. Display it once on first render of the page,
  // then clear in place. Used by the Stripe Connect form POST and any
  // other native-form-driven flow that lands back with an alert.
  const page = usePage<{ flash?: Flash }>()
  useEffect(() => {
    const flash = page.props.flash
    if (!flash) return
    if (flash.alert) toast.error(flash.alert)
    if (flash.notice) toast(flash.notice)
    if (flash.alert || flash.notice) {
      page.props.flash = {}
    }
    // Only on initial mount — the router.on listener handles subsequent
    // Inertia navigations.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
